import { formatDSARReportingData, formatDSARReportingParams } from './format';
import { formatPagingParams, handleError } from '../common/services/helpers';

import API from '/b2b/common/helpers/API';
import { API_NAME } from '#config/runtimeconfig';

export const fetchDSARReportingData = queryStringParameters => {
    const options = {
        queryStringParameters: {
            ...formatPagingParams(queryStringParameters),
            ...formatDSARReportingParams(queryStringParameters),
        },
    };
    return API.get(API_NAME, `/dsar/reporting`, options)
        .catch(handleError)
        .then(formatDSARReportingData);
};
